export default __webpack_public_path__ + "static/empowering-400-b477561319f9aabab024b6cd0cbfc15c.webp";